import { IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { LeavesDTO } from "./leaves.dto";

export class GetEmpAvlLeaves {
    @ApiProperty()
    @IsNotEmpty()
    year: string;
    @ApiProperty()
    @IsNotEmpty({message: 'employeeId should not be empty'})
    employeeId: number;
    @ApiProperty()
    @IsNotEmpty({message: 'Type Of leave should not be empty'})
    typeOfLeave: number;
}